import axiosClient from "../axiosClient";

export const typeCamera = {
    get: () => {
        return axiosClient.get('/cameraType/get-list-camera-type/')
    },
    post: (data) => {
        return axiosClient.post('/cameraType/post-check-camera-hikvision/', data)
    }
} 